import React, { useEffect } from "react";
import {
    Alert,
    Button,
    Card,
    Container,
    Form,
    FormControl,
} from "react-bootstrap";
import { FaExclamationCircle } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router";

import { useAuth } from "../../contexts/auth_provider";
import urls from "../../urls.jsx";

export default function LoginPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [keepSignedIn, setKeepSignedIn] = React.useState(false);
    const emailRef = React.useRef("");
    const passwordRef = React.useRef("");
    const [isSubmitting, setSubmitting] = React.useState(false);
    const [error, setError] = React.useState();
    const { user, login } = useAuth();
    const { from } = location.state || { from: { pathname: "/", search: "" } };

    useEffect(() => {
        if (user) {
            navigate(from.pathname + from.search, { replace: true });
        }
    }, [user, from.pathname, from.search, navigate]);

    function doLogin(event) {
        event.preventDefault();
        setError(undefined);
        setSubmitting(true);

        login(emailRef.current.value, passwordRef.current.value, keepSignedIn)
            .then(() => {
                navigate(from.pathname + from.search, { replace: true });
            })
            .catch((loginError) => {
                if (
                    [
                        "auth/invalid-email",
                        "auth/user-not-found",
                        "auth/wrong-password",
                        "auth/invalid-credential",
                        "auth/invalid-login-credentials",
                    ].includes(loginError.code)
                ) {
                    setError(
                        "Invalid login credentials. Please try again or reset your password.",
                    );
                } else {
                    setError("An error occurred while logging in.");
                }
            })
            .finally(() => {
                setSubmitting(false);
            });
    }

    return (
        <>
            <div className="my-5 text-center">
                <img
                    style={{ maxWidth: "300px", maxHeight: "100px" }}
                    src="/MyCorvus.png"
                    alt="none"
                />
            </div>
            <Container style={{ maxWidth: "400px" }}>
                <title>Login | MyCorvus</title>
                <Card>
                    <Card.Body>
                        {error && (
                            <Alert
                                variant="danger"
                                className="mb-4"
                                onClose={() => setError(undefined)}
                                dismissible
                            >
                                <FaExclamationCircle
                                    className="me-2 text-danger"
                                    style={{ marginTop: "-2px" }}
                                />
                                {error}
                            </Alert>
                        )}
                        <Form onSubmit={doLogin}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    <b>Email address</b>
                                </Form.Label>
                                <FormControl type="email" ref={emailRef} />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label className="">
                                    <b>Password</b>
                                </Form.Label>
                                <FormControl
                                    type="password"
                                    ref={passwordRef}
                                />
                            </Form.Group>
                            <Form.Group
                                className="py-3"
                                controlId="formBasicCheckbox"
                            >
                                <Form.Check
                                    type="checkbox"
                                    label="Keep me signed in"
                                    checked={keepSignedIn}
                                    onChange={(e) =>
                                        setKeepSignedIn(e.target.checked)
                                    }
                                />
                            </Form.Group>
                            <div className="d-grid gap-2">
                                <Button
                                    type="submit"
                                    className="w-100"
                                    disabled={isSubmitting}
                                >
                                    <b>
                                        {isSubmitting
                                            ? "Logging in..."
                                            : "Login"}
                                    </b>
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
            <div className="text-center mt-3">
                {"Can't login? "}
                <Link to={urls.resetPassword()}>Reset password</Link>
            </div>
        </>
    );
}
